import classNames from 'classnames';
import React, { FC } from 'react';

import StarIcon from '@sbu/assets.svg/src/star.svg';
import { IconButton, Tooltip } from '@sumologic/yama-ds-components';

import css from './FavoriteField.module.scss';

interface FavoriteFieldProps {
  disabled?: boolean;
  showIcon?: boolean;
  onClick?: () => void;
}

export const FavoriteField: FC<React.PropsWithChildren<FavoriteFieldProps>> = ({
  children,
  disabled = false,
  onClick,
  showIcon = true,
}) => {
  return (
    <div className={css.container}>
      <div
        className={classNames(css.buttonContainer, {
          [css.inactive]: !showIcon,
        })}
      >
        <Tooltip title={`${showIcon ? 'Disable' : 'Enable'} Favorite Field`}>
          <span>
            <IconButton
              size='medium'
              className={css.button}
              disabled={disabled}
              onClick={onClick}
              sx={{ p: 0 }}
            >
              <StarIcon className={css.icon} />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <div>{children}</div>
    </div>
  );
};
